export type Review = {
  author: string;
  quote: string;
  avatar: string;
  source: string;
};

import krzysztoMentelAvatar from "@/assets/reviews/Krzysztof_Mentel.jpeg";
import jakubSzczepekAvatar from "@/assets/reviews/Jakub-Szczepek.jpeg";
import keithWingateAvatar from "@/assets/reviews/Keith-Wingate.jpeg";
import ehsanGolesorkhi from "@/assets/reviews/Eshan-Golesorki.jpeg";
import yanaLymarAvatar from "@/assets/reviews/Yana-Lymar.jpeg";
import rafalSwierczewskiAvatar from "@/assets/reviews/Rafal-Swierczewski.jpeg";
import justynaZolnaAvatar from "@/assets/reviews/Justyna-zolna.jpeg";
import joannMarekAvatar from "@/assets/reviews/Joanna-Marek.jpeg";
import miroslawSosnaAvatar from "@/assets/reviews/Miroslaw-Sosna.jpeg";
import wojtekPanteraAvatar from "@/assets/reviews/Wojtek-Pantera.jpeg";

// Sourced from LinkedIn recommendations for Wojciech Kluk / Adrian
export const REVIEWS: Review[] = [
  {
    author: "Krzysztof Mętel",
    quote:
      "Wojciech is one of the best recruiters I have met, concrete and cheerful. His qualities are sincerity, professionalism and a bit of humor. Talking with him is a real pleasure, he always finds time to talk even after working hours. I sincerely recommend.",
    avatar: krzysztoMentelAvatar,
    source: "https://positiverecruitment.io/who-we-are/",
  },
  {
    author: "Jakub Szczepek",
    quote:
      "Interview with Wojtek is not standard, but after that you know, You want to have only interviews performed in that way. Skill of getting information and create relation between members of conversation is very high. Although I met Wojtek first time, after a few minutes I felt like I was talking to a good friend. If professionalism is needed, is delivered if stressless time is needed also Wojtek knows when he should create that condition so I think he has very good sensing of needs of candidate during interview. I hope that my cooperation with Wojtek will be continued in the future.",
    avatar: jakubSzczepekAvatar,
    source: "https://positiverecruitment.io/who-we-are/",
  },
  {
    author: "Keith Wingate",
    quote:
      "I was tasked with staffing an operations team in Europe to help complete a 24 x 7 follow-the-sun support calendar. I did not know the market. I do not speak Polish. I couldn't tell you (without google maps) how far Wroclow is from Krakow. Adrian found wonderful talent and really helped me engage with them. He assisted in everything from salary negotiations to advice on labor law and conventions in the EU.\n\nIn addition, he was a really interesting guy to work with and I rarely had a conversation with him where I did not come away a little bit more knowledgeable for having had it.",
    avatar: keithWingateAvatar,
    source: "https://positiverecruitment.io/who-we-are/",
  },
  {
    author: "Ehsan Golesorkhi",
    quote:
      "Wojciech has enough knowledge about IT domain to understand what exactly you are looking for. also he properly supports throw the recruitment process, I also appreciate his fast respond whenever I asked something. He is friendly and professional which made me feel comfortable during the recruitment process.",
    avatar: ehsanGolesorkhi,
    source: "https://positiverecruitment.io/who-we-are/",
  },
  {
    author: "Yana Lymar",
    quote:
      "Wojciech Kluk is a motivated, forward-thinking with lots of knowledge in his field. He is a detail oriented, goal oriented, ambitious and strong co-worker, his knowledge is vast and extensive. Thanks to interpersonal skills he has great relations with both company clients and potential customers. He showed a high level of motivation, friendly, scheduling skills. Wojciech Kluk makes the impossible possible. Was a please to work with him.",
    avatar: yanaLymarAvatar,
    source: "https://positiverecruitment.io/who-we-are/",
  },
  {
    author: "Rafał Świerczewski",
    quote:
      "I would like to recommend Wojciech Kluk as a Recruitment Consultant. He was very professional towards my person, always very easy going and friendly. Each time he got new information I was being told everything within few minutes. He even reach to me on holidays because he received some information there were important. I wish he would lead me towards my new position in the future. Because of his devotion towards details and Knowing his client I think I finally found a team and company that I'll be happy to work with for many years to come.",
    avatar: rafalSwierczewskiAvatar,
    source: "https://positiverecruitment.io/who-we-are/",
  },
  {
    author: "Justyna Zolna",
    quote:
      "Wojtek was my career advisor. I highly appreciate our cooperation. His proffesional insight materialised in achieving my proffesional objectives. Wojtek is a trustful advisor. His easygoing and people oriented approach made it a real pleasure. Looking forward to work with Wojtek again.",
    avatar: justynaZolnaAvatar,
    source: "https://positiverecruitment.io/who-we-are/",
  },
  {
    author: "Mirosław Sosna",
    quote:
      "A positively non-standard and very open approach makes it seem as if I have known Wojtek for a long time. Good technical knowledge helps him determine the level of the candidate well, which makes it easier to go through the next stages of recruitment.",
    avatar: miroslawSosnaAvatar,
    source: "https://positiverecruitment.io/who-we-are/",
  },
  {
    author: "Joanna Marek",
    quote:
      "Working with Wojciech even for that short period of time, before you get a new job, was one of the key moments during my recruitment process. Wojciech definitely made it very easy and gave me a boost of energy and motivation to start a new job. Wojciech is very professional, highly-skilled, definitely knows his profession but what is most important his attitude to people and how he cooperates makes him very outstanding from the other recruiters. He has a fresh and surprising view on how to work with the client, and definitely is a big advantage for the company. He is definitely focusing on finding the perfect match for both sides, employees, and the company. He succeeds in this by trying to understand both sides in depths.",
    avatar: joannMarekAvatar,
    source: "https://positiverecruitment.io/who-we-are/",
  },
  {
    author: "Wojtek Pantera",
    quote:
      "Adrian is a solutions oriented problem solver with a positive mindset. His ability to diagnose a situation, recommend a course of action and get things done has been extremely helpful when we worked together. He is curious and through in seeking to understand his clients' needs and uses his deep understanding of the market to meet and exceed expectations.",
    avatar: wojtekPanteraAvatar,
    source: "https://positiverecruitment.io/who-we-are/",
  },
];
